import Swal from 'sweetalert2';
import OCRScanner from '../components/OCRScanner';
import { createRoot } from 'react-dom/client';
import React from 'react';

const handleAddExpenseMenu = async (navigate, noteId) => {
    Swal.fire({
      title: "Catégorie de dépense",
      html: 
        `<div class="custom-swal-buttons-container">
          <button id="swal-button-ocr" class="swal2-button custom-swal-button ocr-button">
            <i class="fa-solid fa-camera"></i>
            <span class="button-text">Scanner une dépense</span>
          </button>
          <div class="separator">
            <div class="separator-line"></div>
            <span class="separator-text">ou choisir une catégorie :</span>
            <div class="separator-line"></div>
          </div>
          <button id="swal-button1" class="swal2-button custom-swal-button" data-expense-type="hotel">
            <i class="fa-solid fa-hotel"></i>
            <span class="button-text">Hôtel</span>
          </button>
          <button id="swal-button2" class="swal2-button custom-swal-button" data-expense-type="plane">
            <i class="fa-solid fa-plane-departure"></i>
            <span class="button-text">Vol</span>
          </button>
          <button id="swal-button3" class="swal2-button custom-swal-button" data-expense-type="restaurant">
            <i class="fa-solid fa-utensils"></i>
            <span class="button-text">Restaurant</span>
          </button>
          <button id="swal-button4" class="swal2-button custom-swal-button" data-expense-type="taxi">
            <i class="fa-solid fa-taxi"></i>
            <span class="button-text">Taxi</span>
          </button>
          <button id="swal-button5" class="swal2-button custom-swal-button" data-expense-type="carRental">
            <i class="fa-solid fa-hand-holding-dollar"></i>
            <span class="button-text">Location véhicule</span>
          </button>
          <button id="swal-button6" class="swal2-button custom-swal-button" data-expense-type="distance_km">
            <i class="fa-solid fa-location-dot"></i>
            <span class="button-text">Distance/Km</span>
          </button>
          <button id="swal-button7" class="swal2-button custom-swal-button" data-expense-type="carburant">
            <i class="fa-solid fa-gas-pump"></i>
            <span class="button-text">Carburant</span>
          </button>
          <button id="swal-button8" class="swal2-button custom-swal-button" data-expense-type="other">
            <i class="fa-solid fa-question"></i>
            <span class="button-text">Autres</span>
          </button>
        </div>`,
      customClass: {
        popup: 'custom-swal-popup',
        htmlContainer: 'custom-swal-html-container'
      },
      showConfirmButton: false,
      showCloseButton: true,
      focusConfirm: false,
      didOpen: () => {
        // Ajouter des écouteurs d'événements à tous les boutons de catégorie
        document.querySelectorAll('.custom-swal-button[data-expense-type]').forEach(button => {
          button.addEventListener('click', () => {
            const expenseType = button.getAttribute('data-expense-type');
            navigate(`/add-expense/${noteId}/${expenseType}`);
            Swal.close();
          });
        });

        // Ajouter l'écouteur pour le bouton OCR
        const ocrButton = document.getElementById('swal-button-ocr');
        if (ocrButton) {
          ocrButton.addEventListener('click', () => {
            Swal.close();
            handleOCRScan(navigate, noteId);
          });
        }
      }
    });
  };

const handleOCRScan = (navigate, noteId) => {
  // Créer un conteneur temporaire pour le composant OCRScanner
  const ocrContainer = document.createElement('div');
  document.body.appendChild(ocrContainer);

  const cleanupOCRContainer = () => {
    // Vérification sécurisée avant suppression
    if (ocrContainer && ocrContainer.parentNode === document.body) {
      try {
        document.body.removeChild(ocrContainer);
      } catch (error) {
        console.warn('Conteneur OCR déjà supprimé:', error);
      }
    }
  };

  const handleOCRData = (ocrData) => {
    
    // Détecter le type de dépense depuis l'OCR ou utiliser 'other' par défaut
    const detectedType = ocrData.expense_type || 'other';
    
    // Nettoyer le conteneur OCR de façon sécurisée
    cleanupOCRContainer();
    
    // Naviguer vers le formulaire avec le type détecté et pré-remplir les données
    navigate(`/add-expense/${noteId}/${detectedType}`, { 
      state: { 
        ocrData: ocrData 
      } 
    });
  };

  const handleOCRClose = () => {
    // Nettoyer le conteneur OCR de façon sécurisée
    cleanupOCRContainer();
  };

  // Créer et monter le composant OCRScanner
  const root = createRoot(ocrContainer);
  root.render(
    React.createElement(OCRScanner, {
      onDataExtracted: handleOCRData,
      onClose: handleOCRClose
    })
  );
  };

export { handleAddExpenseMenu };